import { configureStore, combineReducers } from '@reduxjs/toolkit';
import projectSlice from './projectSlice';
import contractorSlice from './contractorSlice';
import authSlice from './slices/authSlice';
import realTimeSlice from './slices/realTimeSlice';

// Redux store with projects, contractors, auth, and realTime slices.
// AuthContext also manages auth UI state; Redux auth slice provides typed state for hooks.
const rootReducer = combineReducers({
  projects: projectSlice,
  contractors: contractorSlice,
  auth: authSlice,
  realTime: realTimeSlice
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: true
    })
});

